/** Conservative nearby invite arrival; never falls back to a distant world spawn. */
import {MOVEMENT,worldColliders} from './movement.mjs';
import {isSafePortalExit,isSpawnSafetyPrepared} from './spawn-safety.mjs';
export const INVITE_NEARBY_RADIUS=8;
function clearSegment(a,b,boxes) {
  for(const box of boxes) {
    if((box.maxY??100)<=b.y+.001||(box.minY??0)>=b.y+MOVEMENT.height-.001)continue;
    let lo=0,hi=1;
    for(const axis of ['x','z']) {
      const min=box[axis==='x'?'minX':'minZ']-MOVEMENT.radius,max=box[axis==='x'?'maxX':'maxZ']+MOVEMENT.radius,d=b[axis]-a[axis];
      if(Math.abs(d)<1e-9){if(a[axis]<=min||a[axis]>=max){lo=2;break;}}
      else {const one=(min-a[axis])/d,two=(max-a[axis])/d;lo=Math.max(lo,Math.min(one,two));hi=Math.min(hi,Math.max(one,two));}
    }
    if(lo<hi&&hi>0&&lo<1)return false;
  }
  return true;
}
export function findNearbyInviteSpawn(world,anchor,{players=[],excludePlayerId=null}={}) {
  if(!isSpawnSafetyPrepared(world)||!anchor||![anchor.x,anchor.y,anchor.z].every(Number.isFinite))return null;
  const boxes=worldColliders(world),r=MOVEMENT.radius+.12;
  const heights=[...new Set([0,...boxes.map(b=>b.maxY??100)])].filter(y=>Math.abs(y-anchor.y)<=1.25).sort((a,b)=>Math.abs(a-anchor.y)-Math.abs(b-anchor.y));
  for(const radius of [1.5,2.25,3,4.5,6,8])for(let angle=0;angle<16;angle++)for(const y of heights) {
    const p={x:anchor.x+radius*Math.cos(angle*Math.PI/8),y,z:anchor.z+radius*Math.sin(angle*Math.PI/8)};
    if(y!==0&&!boxes.some(b=>Math.abs((b.maxY??100)-y)<.001&&p.x-r>=b.minX&&p.x+r<=b.maxX&&p.z-r>=b.minZ&&p.z+r<=b.maxZ))continue;
    if(!isSafePortalExit(p,world,{preparedOnly:true})||!clearSegment(anchor,p,boxes))continue;
    if(players.some(other=>other.id!==excludePlayerId&&other.worldId===world.id&&other.position&&Math.abs(other.position.y-p.y)<MOVEMENT.height&&Math.hypot(other.position.x-p.x,other.position.z-p.z)<MOVEMENT.radius*2+.3))continue;
    if((world.portals??[]).some(portal=>Math.abs(portal.position.y-p.y)<MOVEMENT.height&&Math.hypot(portal.position.x-p.x,portal.position.z-p.z)<(portal.width??3.2)/2+1))continue;
    return p;
  }
  return null;
}
export function invitedPlayer(player,world,position) {
  return {...player,worldId:world.id,position:{...position},velocityX:0,velocityY:0,velocityZ:0,flying:false,grounded:true,jumpHeld:false,coyoteRemaining:0,jumpBufferRemaining:0,activePortalId:null,lastPortalId:null,portalCooldownRemaining:0,lastCrossing:null,portalTraversal:null};
}
